module.exports = "pegasus_template/assets/tech/conference/100.png";